import React, { Fragment } from 'react';
import _ from 'lodash';

// let rows = [
// 	['id', 'name', 'image','id', 'name', 'image'],
// 	['1', 'bob', 'bobo','1', 'bob', 'bobo'],
// 	['2', 'sue', 'susesd','2', 'sue', 'susesd'],
// 	['1', 'bob', 'bobo','1', 'bob', 'bobo'],
// 	['2', 'sue', 'susesd','2', 'sue', 'susesd'],
// 	['1', 'bob', 'bobo','1', 'bob', 'bobo'],
// 	['2', 'sue', 'susesd','2', 'sue', 'susesd'],	
// ];


export default class Table extends React.Component{ 
	
	constructor(...args){
		super(...args);
		this.state = {}
	}

	get rows(){
		return this.props.rows;
	}
	
	render(){
		this.editInput = null;
		let rows = this.rows;
		let columns = _.range(0, _.max(rows.map( row => row.length)));

		return (
			<table className="Table">
				<thead>
					<tr> 
					{ columns.map( (column, columnIndex) => 
						<th key={columnIndex}>
							<TableInput row={rows[0]} columnIndex={columnIndex} rows={rows} />
						</th>
					)}
					</tr>
				</thead>
				<tbody>
					{ rows.slice(1).map( (row, rowIndex) =>
						<tr key={rowIndex + 1}> 
							{ columns.map( (column, columnIndex) => 
								<td key={columnIndex}>
									<TableInput row={rows[rowIndex+1]} columnIndex={columnIndex} rows={rows} />
								</td>
							)}
						</tr>
					)}
				</tbody>
			</table>
		);
	}

}

class TableInput extends React.Component{

	render(){
		let row = this.props.row;
		let columnIndex = this.props.columnIndex;

		let app = window.app;

		let onContextMenu = (e) =>{
			let rows = this.props.rows;
			e.preventDefault();
			const options = [
				{label:'Add Row', onClick: () => {
					let index = rows.indexOf(row);
					let newRow = [...row];
					_.fill(newRow, '');
					rows.splice(index + 1, 0, newRow);
					app.closeContextMenu();
				}},
				{label:'Delete Row', onClick: () => { _.pull(rows, row); app.closeContextMenu(); }},
				{label:'Add Column', onClick: () => { 
					rows.forEach( tempRow => {
						tempRow.splice(columnIndex + 1, 0, '');
					});
					app.closeContextMenu();
				}},
				{label:'Delete Column', onClick: () => {
					rows.forEach( tempRow => {
						tempRow.splice(columnIndex, 1);
					});
					app.closeContextMenu();
				}},
			];

			app.showContextMenu({ anchorEl:e.currentTarget, options });
		}


		return (
			<Fragment>
				<input type="text" onContextMenu={onContextMenu} value={row[columnIndex] || ''} onChange={e =>  {row[columnIndex] = e.currentTarget.value; app.experiment.debouncedSave(); this.forceUpdate()}} />
				{row[columnIndex]}
			</Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Table.js